import { ChangeDetectionStrategy, Component, input, OnChanges, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormLabelComponent } from '@ui-kit/form';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';

@Component({
    selector: 'searchbar',
    templateUrl: './searchbar.component.html',
    styleUrls: ['./searchbar.component.scss'],
    imports: [InputGroupModule, InputTextModule, FormsModule, TranslateModule, ButtonModule, FormLabelComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchbarComponent implements OnChanges {
    id = input.required<string>();
    value = input.required<string>();

    placeholder = input<string>('uiKit.miscs.searchbar.placeholder');
    label = input<string>('');
    maxLength = input<number>(500);
    disabled = input<boolean>(false);
    isLoading = input<boolean>(false);
    shouldDisplaySearchIcon = input<boolean>(true);

    onSearch = output<string>();
    onSearchWithDebounce = output<string>();
    onBlur = output<string>();

    controlValue = signal<string>('');
    searchbarFocus = signal<boolean>(false);

    /** Last value we emitted or had at focus; on blur we only emit if value changed. */
    private previousValue = '';
    private isBlurring = false;

    ngOnChanges() {
        if (this.controlValue() === this.value()) {
            return;
        }
        this.controlValue.set(!this.value() ? '' : this.value());
    }

    onFocusInput(): void {
        if (!this.isBlurring) {
            this.previousValue = this.controlValue();
        }
        this.isBlurring = false;
        this.searchbarFocus.set(true);
    }

    search(): void {
        this.previousValue = this.controlValue();
        this.onSearch.emit(this.controlValue());
    }

    searchWithDebounce(): void {
        this.onSearchWithDebounce.emit(this.controlValue());
    }

    onBlurInput(): void {
        this.searchbarFocus.set(false);
        this.isBlurring = true;
        setTimeout(() => {
            const current = this.controlValue();
            if (current.trim() === this.previousValue.trim()) {
                this.isBlurring = false;
                return;
            }
            this.previousValue = current;
            this.isBlurring = false;
            this.onBlur.emit(current);
        }, 100);
    }

    clear(event: any): void {
        if (this.disabled()) {
            return;
        }

        event.stopPropagation();
        this.controlValue.set('');
        this.previousValue = '';
        this.search();
        this.searchWithDebounce();
    }

    checkSearchInputValue() {
        if (this.controlValue() === '') {
            this.search();
            this.searchWithDebounce();
        }
    }
}
